import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
import { IPays } from '@core';
import { CustomValidators } from '@core-lib/classes';

@Directive({
    selector: '[iban]',
    standalone: false
})
export class IbanDirective {
	@Input('ibanForm') ibanForm: AbstractControl;
	@Input('checkOnChangePays') checkOnChangePays: boolean = false;

	@Input()
	set pays(value: IPays) {
		this._pays = value;
		if (value && this.checkOnChangePays) {
			this.validateIbanFormat(value);
		} else {
			this.ibanForm.setValidators(Validators.required);
			this.ibanForm.updateValueAndValidity({ emitEvent: false });
		}
	}
	private _pays: IPays;
	get pays(): IPays {
		return this._pays;
	}

	inputElement: HTMLInputElement;

	constructor(private el: ElementRef) {
		this.inputElement = el.nativeElement;
	}

	@HostListener('blur', ['$event']) onBlur($event): void {
		const value: string = this.inputElement.value;
		if (!value) {
			return;
		}
		//valider format IBAN suivant le paramétrage dans le pays
		if (this.ibanForm && this.pays) {
			this.validateIbanFormat(this.pays);
		}
		$event.target.value = value
			.split(' ')
			.join('')
			.replace(/(.{4})/g, '$1 ');
	}

	@HostListener('keydown', ['$event']) onKeydown($event): void {
		if ($event.key == 'Enter') {
			const value: string = this.inputElement.value;
			if (!value) {
				return;
			}
			if (this.ibanForm && this.pays) {
				this.validateIbanFormat(this.pays);
			}
			
		} else if ($event.key != 'Backspace' && $event.key != 'ArrowLeft') {
			let target = $event.target,
				position = target.selectionEnd,
				length = target.value.length;
			target.value = target.value
				.replace(/[^\dA-Z]/g, '')
				.replace(/(.{4})/g, '$1 ')
				.trim();
			if (position % 5 == 4) {
				position = position + 1;
			}
			target.selectionEnd = position +=
				target.value.charAt(position - 1) === ' ' && target.value.charAt(length - 1) === ' ' && length !== target.value.length
					? 1
					: 0;
		}
	}

	@HostListener('input', ['$event']) onInput($event) {
		this.ibanForm.setValidators(Validators.required);
		this.ibanForm.updateValueAndValidity({ emitEvent: false });
	}

	@HostListener('focus', ['$event']) onFocus($event) {}

	validateIbanFormat(pays: IPays) {
		this.ibanForm.setValidators([
			Validators.required,
			CustomValidators.ibanLength(pays.nom, pays.longueurIBAN),
			CustomValidators.respectFormatISO(0, 1, pays.codeISO, pays.paysParent?.codeISO),
			CustomValidators.wrongIbanKey()
		]);
		this.ibanForm.updateValueAndValidity({ emitEvent: false });
	}
}
